import React, { useEffect, useState } from "react";
import { Col, Row, Typography, message, Input, Tooltip } from "antd";
import Button from "../../../Button";
import { useClients } from "../../../../contexts/ClientsContext";
import { Container } from "./styles";
import { FiCopy } from "react-icons/fi";
import api from "../../../../services/api";
import { apiPayment } from "../../../../services/payment";
import { useAuth } from "../../../../contexts/AuthContext";
import { getPlanPrice, planos } from "../../../Planos/planos";
import { UserPlanEnum } from "../../../../constants/plans";

interface PaymentLinkProps {
  backStep?: () => void;
  paymentData: any;
}

export const PaymentLink: React.FC<PaymentLinkProps> = ({
  backStep,
  paymentData
}) => {
  const { selectedClient } = useClients();
  const [link, setLink] = useState("");
  const { user } = useAuth();

  const plano = planos.find(p => p.type === paymentData.type)
  const price = getPlanPrice(plano!, false) ?? 25.9;
  const installments = plano?.installments || 1;
  let totalPrice = price * installments;

  const getDiscount = () => {
    if (paymentData.type === UserPlanEnum.VELOTAX_MAIN_PRO) {
      if (user?.user?.discount! >= 33) return 33.38898164;
      else return user?.user?.discount || 0;
    }
    if (paymentData.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) {
      if (user?.user?.discount! >= 50) return 50.06257822;
      return user?.user?.discount || 0;
    }
    else return user?.user?.discount || 0
  }

  if (user.user.discount && paymentData.type !== UserPlanEnum.VELOTAX_MAIN_BASIC)
    totalPrice -= totalPrice * (getDiscount() / 100);
  const planPrice = totalPrice / installments;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${link}`)
      .then(() => {
        message.success('Link copiado!')
      })
      .catch((err) => {
        message.error('Falha ao copiar texto: ', err);
      });
  };

  const getTokenToCheckout = async () => {
    const token = localStorage.getItem("@VeloTax:token");
    if (!token) {
      message.error("Token não encontrado. Recarregue sua página");
      return;
    }
    const { data } = await apiPayment.get("/pro/checkout/token", {
      params: {
        provider: "VELOPRIME",
        userId: selectedClient?.userId || "",
        plan: paymentData,
        amount: planPrice * 12
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    setLink(`${process.env.REACT_APP_CHECKOUT_URL}link/${data.token}`)
  }

  useEffect(() => {
    getTokenToCheckout();
  }, [selectedClient])

  const sendToWpp = () => {
    const text = `Olá, ${selectedClient?.name || "Cliente"}. Segue o seu link de pagamento: ${link}`;
    const url = `https://wa.me${selectedClient?.phone ? `/55${selectedClient?.phone}` : ""}?text=${text.replaceAll(" ", "%20")}`;
    window.open(url, "_blank");
  }

  const sendMail = async () => {
    try {
      const clientToEmail = { ...selectedClient, linkUrl: `${link}` }
      await api.post("/clients/send-mail", {
        type: "link-checkout",
        linkUrl: `${link}`,
        clients: [clientToEmail],
      });
      message.success("Link de pagamento enviado por e-mail!");
    } catch {
      message.error("Algo inesperado aconteceu. Tente novamente");
    }
  };

  return (
    <Col>
      <Container>
        <Row>
          <Col>
            <Typography style={{ color: "var(--velotax-font-color-dark)" }}>
              Copie o link de pagamento ou envie via e-mail ou WhatsApp.{" "}
            </Typography>
          </Col>
        </Row>
        <Col className="input-div">
          <Input className="input-checkout" disabled={true} value={link} />
          <Tooltip title="Copiar link">
            <FiCopy className="icon-copy" onClick={copyToClipboard} size={20} />
          </Tooltip>
        </Col>
        <Button type="primary" size="large" onClick={sendToWpp}>Enviar link por WhatsApp</Button>
        <Button type="primary" size="large" onClick={sendMail}>Enviar link por E-mail</Button>
      </Container>
      <Button
        size="middle"
        type="default"
        onClick={() => backStep && backStep()}
      >
        <span className="xp-link uppercase">Voltar</span>
      </Button>
    </Col>
  );
};
